<template>
  <div>

    <v-layout 
    @click="expand = !expand"
    align-center
    class="pa-2 cursor-pointer">
      <v-icon small :class="[{'rotate-90': expand}]">mdi-chevron-right</v-icon>
      <span class="ml-2">
        Categories
      </span>
      <div class="c-hr ml-3 mr-3" style="flex: 1;"></div>
    </v-layout>

    <v-expand-transition>
      <div v-show="expand">
        <category-card class="" :onClick="onClick" :selected.sync="localSelected" :widgetMode="widgetMode"></category-card>
      </div>
    </v-expand-transition>

  </div>
</template>

<script>
import CategoryCard from './Card'
import CTreeView from '@/components/ui/tree-view/C-TreeView'
import Vue from 'vue'

export default {
  components: {
    CTreeView,
    CategoryCard
  },
  props: ['selected', 'widgetMode', 'onClick'],
  data () {
    return {
      expand: false,
      localSelected: []
    }
  },
  watch: {
    selected (nv) {
      this.localSelected = nv
    },
    localSelected (nv) {
      this.$emit('update:selected', nv)
    }
  }
}
</script>
